import React from "react";
import { Ban, MessageSquare, Plus, Users } from "lucide-react";

import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import { PRESETS, type Preset } from "./presets";

const ICONS = { plus: Plus, ban: Ban, users: Users, chat: MessageSquare };
const menuCls = "w-[280px] p-1 rounded-[12px] bg-[var(--surface)] border border-[var(--hairline-strong)] shadow-menu";

/* The "+" on the line between two policies: it opens the presets, and the one picked goes
   there. */
export function AddPolicy({ disabled, onAdd }: { disabled?: boolean; onAdd: (preset: Preset) => void }) {
  return (
    <div className="flex flex-col items-center">
      <span aria-hidden="true" className="w-px h-2.5 bg-[var(--hairline-strong)]" />
      <DropdownMenu>
        <DropdownMenuTrigger asChild disabled={disabled}>
          <button
            type="button"
            aria-label="Add a policy here"
            title="Add a policy here"
            className="press w-6 h-6 rounded-[7px] flex items-center justify-center bg-[var(--surface)] text-[var(--text-secondary)] ring-1 ring-[var(--hairline-strong)] hover:bg-[var(--text-primary)] hover:text-[var(--surface)] data-[state=open]:bg-[var(--text-primary)] data-[state=open]:text-[var(--surface)] disabled:opacity-40"
          >
            <Plus className="w-3 h-3" strokeWidth={2.25} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="center" className={menuCls}>
          <DropdownMenuLabel className="px-2 pt-1.5 pb-1 text-[11.5px] font-medium text-[var(--text-tertiary)]">Add a policy</DropdownMenuLabel>
          {PRESETS.map((preset) => {
            const Icon = ICONS[preset.icon];
            return (
              <DropdownMenuItem
                key={preset.label}
                onSelect={() => onAdd(preset)}
                className="flex items-start gap-2.5 px-2 py-[7px] rounded-[8px] cursor-pointer focus:bg-[var(--accent-hover)]"
              >
                <span className="w-7 h-7 shrink-0 rounded-[8px] bg-[var(--surface-2)] flex items-center justify-center text-[var(--text-secondary)]">
                  <Icon className="w-[14px] h-[14px]" strokeWidth={1.75} />
                </span>
                <span className="min-w-0">
                  <span className="block text-[13px] font-medium text-[var(--text-primary)]">{preset.label}</span>
                  <span className="block text-[11.5px] leading-[1.45] text-[var(--text-tertiary)]">{preset.hint}</span>
                </span>
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
      <span aria-hidden="true" className="w-px h-2.5 bg-[var(--hairline-strong)]" />
    </div>
  );
}
